import { GENERAL_EVENTS } from '@/const/events';
import { parseLaquesisCookie } from '@/cookies/laquesis';
import { ninjaBus } from '@/eventbus';
import { state } from '@/ninja/state';

/**
 * This is needed for the cookie watcher feature
 * @see https://naspersclassifieds.atlassian.net/wiki/x/XILGhA0
 */
export function overrideLaquesisResultsPush(callback: (name: string, variant: string) => void) {
  window.laquesisResults = window.laquesisResults || [];

  const currentLqPush = window.laquesisResults.push;
  window.laquesisResults.push = params => {
    const result = currentLqPush.apply(window.laquesisResults, [params]);
    ninjaBus.emit(GENERAL_EVENTS.TRACK_FEATURE_USAGE, '', { message: 'laquesis/cookie watcher used: ' + params.newResult });

    // If the first tracked page event has already been emitted, we can check the results immediately.
    // Otherwise, the results will be checked when the first page event is emitted.
    // Server-executed experiments need to have the page property. Dalying the tracking ensures this event is present.
    // LaquesisTracker listens for `GENERAL_EVENTS.FIRST_PAGE_TRACKED` and calls `checkResults` when it's emitted, which will process `laquesisResult` enties
    if (state.firstTrackedPageEvent) {
      checkResults(callback);
    }
    return result;
  };
}

/**
 * Check if there are new items in the laquesisResults array and process them
 */
export function checkResults(callback: (name: string, variant: string) => void) {
  if (window.laquesisResults && Array.isArray(window.laquesisResults)) {
    for (const data of window.laquesisResults) {
      if (typeof data === 'object' && !data.processed && data.newResult !== undefined) {
        data.processed = true;
        const newTests = parseLaquesisCookie(data.newResult, callback);
        state.activeExps = new Map([...state.activeExps, ...newTests]);
      }
    }
  }
}
